module.exports = __webpack_public_path__ + "img/55.16d2da02.png";